<div class="card-block">
    <admin-view-content [data]="data" [loading]="false" [reload]="" [table_info]="table_info" [selectDataMode]="selectDataMode"></admin-view-content>
</div>
